import axios from "../../../configs/axios";

export interface ProductSheet {
  id: string;
  sheetName: string;
  version: string;
  category: string;
  description?: string;
  downloadKey?: string;
  downloads: number;
  fileSize?: string;
  fileType?: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateProductSheetRequest {
  sheetName: string;
  version: string;
  category: string;
  description?: string;
  downloadKey?: string;
  fileSize?: string;
  fileType?: string;
}

export interface UpdateProductSheetRequest
  extends Partial<CreateProductSheetRequest> {}

export const productSheetsAPI = {
  getAllProductSheets: async (search?: string) => {
    const params = search ? { search } : {};
    const response = await axios.get("/admin/product-sheets", { params });
    return response.data.data; // Extract the actual data array
  },

  getProductSheetById: async (id: string) => {
    const response = await axios.get(`/admin/product-sheets/${id}`);
    return response.data.data; // Extract the actual data
  },

  createProductSheet: async (data: CreateProductSheetRequest) => {
    const response = await axios.post("/admin/product-sheets", data);
    return response.data.data; // Extract the actual data
  },

  updateProductSheet: async (id: string, data: UpdateProductSheetRequest) => {
    const response = await axios.put(`/admin/product-sheets/${id}`, data);
    return response.data.data; // Extract the actual data
  },

  deleteProductSheet: async (id: string) => {
    const response = await axios.delete(`/admin/product-sheets/${id}`);
    return response.data; // This returns just the success message, no data field
  },

  downloadProductSheet: async (id: string) => {
    const response = await axios.post(`/admin/product-sheets/${id}/download`);
    return response.data.data; // Extract the actual download data
  },
};

export const s3API = {
  uploadFile: async (
    file: File,
    folder: string,
    name: string,
    version: string
  ) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("folder", folder);
    formData.append("name", name);
    formData.append("version", version);

    const response = await axios.post("/s3/upload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  },

  // Convenience method for product sheets
  uploadProductSheetFile: async (
    file: File,
    sheetName: string,
    version: string
  ) => {
    return s3API.uploadFile(file, "sheets", sheetName, version);
  },
};
